<template>
  <div>
    <el-dialog v-bind='$attrs' v-on='$listeners' @opened='onOpened' @close='onClose' :title='dialogTitle'
               width='80%'>
      <!--    列表-->
      <bonus-table :search-condition='searchCondition' :edit-mode='true' @getInfo='getInfo'
                   ref="bonusTable"   @editVal='editVal'></bonus-table>
      <!--     -->
      <!--    操作项-->
      <div style='border-top: #f2f2f2 1px solid;padding-top: 10px;margin-top: 10px'>
        <bonus-handle :group_id='groupId'
                      :ym.sync='ym'
                      :current-bonus-bill='currentBonusBill' :current-data-list='dataList'
                      @savedMember="savedMember"   @saved='saved()'/>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import BonusTable from './BonusTable'
import BonusHandle from './BonusHandle'

export default {
  name: 'BonusManagementComponentBonusEdit',
  components: {
    BonusTable, BonusHandle
  },
  props: {
    id: {
      type: [String, Number],
      default() {
        return null
      }
    },

  },
  computed: {

    groupId() {
      return this.currentBonusBill.group_id
    },
    ym() {
      return `${this.currentBonusBill.year}-${this.currentBonusBill.date_value}`
    }
  },
  data() {
    return {
      searchCondition: {id: null},
      currentBonusBill: {},
      dialogTitle: '',
      dataList: []//当前表格数据

    }
  },
  methods: {
    getDialogTitle() {
      this.dialogTitle = `奖金分配 - 【${this.currentBonusBill.dept_name || ''}】${this.currentBonusBill.year || ''}年${this.currentBonusBill.date_value || ''}月`
    },
    onOpened() {
      this.searchCondition = {id: this.id}
      this.getDialogTitle()

    },
    onClose() {

    },
    getInfo(val) {
      this.currentBonusBill = val
      this.getDialogTitle()

    },
    editVal(val) {
      this.dataList = val
    },
    saved() {
      this.$emit('close')
    },
    savedMember(){
      this.$refs['bonusTable'].initList()
      this.$emit('savedMember')

    }
  }

}
</script>

<style scoped>

</style>
